module.exports = __webpack_public_path__ + "img/Andrew Sorrell.326d165b.jpg";